import { render, staticRenderFns } from "./UtilsPanelStatic.vue?vue&type=template&id=3fad2f8c&scoped=true&"
import script from "./UtilsPanelStatic.vue?vue&type=script&lang=js&"
export * from "./UtilsPanelStatic.vue?vue&type=script&lang=js&"
import style0 from "./UtilsPanelStatic.vue?vue&type=style&index=0&id=3fad2f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fad2f8c",
  null
  
)

export default component.exports